// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "Poppins", sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  /* Remove the scrollbar in Firefox */
  scrollbar-width: thin; /* Thin scrollbar width for Firefox */
  scrollbar-color: #888 #f1f1f1; /* Scrollbar color for Firefox */
}

/* Scrollbar styles for Webkit-based browsers (Chrome, Safari, etc.) */
::-webkit-scrollbar {
  width: 8px; /* Width of the scrollbar */
}

::-webkit-scrollbar-track {
  background: #f1f1f1; /* Background color of the scrollbar track */
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: #888; /* Color of the scrollbar thumb */
  border-radius: 10px; /* Rounded corners for the scrollbar thumb */
  border: 2px solid #f1f1f1; /* Optional: border around the scrollbar thumb */
}

::-webkit-scrollbar-thumb:hover {
  background: #555; /* Color when hovering over the scrollbar thumb */
}

#cx-main {
  transition: all 0.5s;
  padding: 60px 20px 20px 20px;
  min-height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
}

.cx-btn-1 {
  cursor: pointer;
  background-color: #53b7e8;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #ffffff;
  border-radius: 10px;
  padding: 7px 20px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}
.cx-btn-2 {
  cursor: pointer;
  background-color: #7353e8;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #ffffff;
  border-radius: 10px;
  padding: 7px 20px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}
.cx-btn-3 {
  cursor: pointer;
  background-color: rgba(83, 183, 232, 0.1);
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #53b7e8;
  border-radius: 10px;
  padding: 7px 20px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}
.cx-input-1 {
  font-size: 14px;
  line-height: 2.5 !important;
  height: 38px;
  border: 0.956px solid #53b7e8 !important;
  border-radius: 5px !important;
  background-color: #ffffff !important;
  color: #000000 !important;
}
.cx-input-1::placeholder {
  color: gray !important;
  font-size: 14px;
}

.cx-input-2 {
  font-size: 14px;
  line-height: 2.5 !important;
  height: 38px;
  border: 0.956px solid #53b7e8 !important;
  border-radius: 5px !important;
  background-color: #ffffff !important;
  color: #000000 !important;
}
.cx-input-2::placeholder {
  color: gray !important;
  font-size: 14px;
}

.cx-input-radio {
  font-size: 14px;
  line-height: 2.5 !important;
  border-radius: 5px !important;
  background-color: #ffffff !important;
  color: #000000 !important;
}
.cx-input-radio::placeholder {
  color: gray !important;
  font-size: 14px;
}

.cx-input-check {
  font-size: 14px;
  line-height: 2.5 !important;
  height: 38px;
  border-radius: 5px !important;
  background-color: #ffffff !important;
  color: #000000 !important;
}
.cx-input-check::placeholder {
  color: gray !important;
  font-size: 14px;
}

.cx-heading-1 {
  font-weight: 600;
  font-size: 18px;
  color: rgba(17, 17, 17, 0.8);
}

.cx-heading-2 {
  font-weight: 600;
  font-size: 16px;
  color: rgba(17, 17, 17, 0.8);
}

.cx-heading-3 {
  font-weight: 600;
  font-size: 14px;
  color: rgba(209, 38, 38, 0.8);
}

.cx-label-1 {
  font-weight: 400;
  font-size: 14px;
  color: rgba(17, 17, 17, 0.6);
}

.cx-label-2 {
  font-weight: 400;
  font-size: 14px;
  color: rgba(17, 17, 17, 0.6);
}

.cx-key {
  font-weight: 400;
  font-size: 12px;
  color: rgba(17, 17, 17, 0.5);
}

.cx-value {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #111111;
}

.cx-bt {
  border-top: 1px solid #ddeaf3;
}

.cx-bb {
  border-bottom: 1px solid #ddeaf3;
}

.cx-br {
  border-right: 1px solid #ddeaf3;
}

.cx-bl {
  border-left: 1px solid #ddeaf3;
}

.cx-b {
  border: 1px solid #ddeaf3;
}

.cx-card {
  padding: 20px;
  background: #ffffff;
  border: 0.956px solid rgba(135, 135, 135, 0.1);
  box-shadow: 4px 4px 10px rgba(182, 182, 182, 0.1);
}

.cx-card-round {
  background: #ffffff;
  border: 0.956px solid rgba(135, 135, 135, 0.1);
  box-shadow: 4px 4px 10px rgba(182, 182, 182, 0.1);
  border-radius: 15px;
  padding: 30px;
}

.cx-circle {
  height: 40px;
  width: 40px;
  border-radius: 50%;
}

.cx-circle-5 {
  border-radius: 5px;
}

.cx-circle-10 {
  border-radius: 10px;
}

.cx-circle-20 {
  border-radius: 20px;
}

.cx-circle-15 {
  border-radius: 15px;
}

.cx-vh100 {
  height: 100vh;
}

.cx-vh50 {
  height: 50vh;
}

.cx-vw100 {
  width: 100%;
}

.cx-m-0 {
  margin: 0;
}

.cx-m-5 {
  margin: 5px;
}

.cx-m-10 {
  margin: 10px;
}

.cx-m-15 {
  margin: 15px;
}

.cx-m-20 {
  margin: 20px;
}

.cx-m-30 {
  margin: 30px;
}

.cx-m-40 {
  margin: 40px;
}

.cx-m-50 {
  margin: 50px;
}

.cx-mt-0 {
  margin-top: 0;
}

.cx-mt-5 {
  margin-top: 5px;
}

.cx-mt-10 {
  margin-top: 10px;
}

.cx-mt-15 {
  margin-top: 15px;
}

.cx-mt-20 {
  margin-top: 20px;
}

.cx-mt-25 {
  margin-top: 25px;
}

.cx-mt-30 {
  margin-top: 30px;
}

.cx-mt-35 {
  margin-top: 35px;
}

.cx-mt-40 {
  margin-top: 40px;
}

.cx-mt-50 {
  margin-top: 50px;
}

.cx-mt-60 {
  margin-top: 60px;
}

.cx-mt-70 {
  margin-top: 70px;
}

.cx-mt-80 {
  margin-top: 80px;
}

.cx-mt-90 {
  margin-top: 90px;
}

.cx-mt-100 {
  margin-top: 100px;
}

.cx-mb-0 {
  margin-bottom: 0;
}

.cx-mb-5 {
  margin-bottom: 5px;
}

.cx-mb-10 {
  margin-bottom: 10px;
}

.cx-mb-15 {
  margin-bottom: 15px;
}

.cx-mb-20 {
  margin-bottom: 20px;
}

.cx-mb-25 {
  margin-bottom: 25px;
}

.cx-mb-30 {
  margin-bottom: 30px;
}

.cx-mb-35 {
  margin-bottom: 35px;
}

.cx-mb-40 {
  margin-bottom: 40px;
}

.cx-mb-50 {
  margin-bottom: 50px;
}

.cx-mb-60 {
  margin-bottom: 60px;
}

.cx-mb-70 {
  margin-bottom: 70px;
}

.cx-mb-80 {
  margin-bottom: 80px;
}

.cx-mb-90 {
  margin-bottom: 90px;
}

.cx-mb-100 {
  margin-bottom: 100px;
}

.cx-ml-0 {
  margin-left: 0px;
}

.cx-ml-5 {
  margin-left: 5px;
}

.cx-ml-10 {
  margin-left: 10px;
}

.cx-ml-15 {
  margin-left: 15px;
}

.cx-ml-20 {
  margin-left: 20px;
}

.cx-ml-25 {
  margin-left: 25px;
}

.cx-ml-30 {
  margin-left: 0px;
}

.cx-ml-40 {
  margin-left: 40px;
}

.cx-mr-0 {
  margin-right: 0px;
}

.cx-mr-5 {
  margin-right: 5px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar {
  height: 5px;
  width: 5px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgb(5, 93, 157);
}

.cx-flex-all {
  display: flex;
  align-items: center;
  justify-content: center;
}

.cx-flex-x {
  justify-content: center;
}

.cx-flex-y {
  align-items: center;
}

.cx-p-r {
  position: relative;
}

.cx-p-a {
  position: absolute;
}

.cx-p-f {
  position: fixed;
}

.cx-p-s {
  position: sticky;
}

.cx-p-center {
  position: absolute;
  left: 50%;
  right: 50%;
  transform: translate(-50%, -50%);
}

body {
  --backColorMainLightMode: #beddda;
  --backColorMainDarksecond: #ddeaf3;
  --gray_05_LightMode: rgba(17, 17, 17, 0.5);
  --gray_08_LightMode: rgba(17, 17, 17, 0.8);
  --gray_03_LightMode: rgba(17, 17, 17, 0.3);
  --gray_02_LightMode: rgba(17, 17, 17, 0.2);
  --gray_455A64_LightMode: #455a64;
  --gray_666666_LightMode: #666666;
  --gray_81888C_LightMode: #ddeaf3;
  --green_06685E_LightMode: #06685e;
  --green_3DA298_LightMode: #3da298;
  --greenLight_3DA298_LightMode: rgba(61, 162, 152, 0.1);
  --greenLight_3DA298_02_LightMode: rgba(61, 162, 152, 0.2);
  --green_009253_LightMode: #009253;
  --blueBorderColor_53B7E8_LightMode: #53b7e8;
  --greenBorderColor_3DA298_LightMode: #3da298;
  --blue_53B7E8_LightMode: #53b7e8;
  --blueLight_53B7E8_LightMode: rgba(83, 183, 232, 0.1);
  --blue_deeplight_EEF8FD: #eef8fd;
  --red_EE1D52_LightMode: #ee1d52;
  --black_111111_LightMode: #111111;
  --black_232122_LightMode: #232122;
  --black_000000_LightMode: #000000;
  --black_333333_LightMode: #333333;
  --white_FFFFFF_LightMode: #ffffff;
  --white_FFFBFB_LightMode: #fffbfb;
}

.cx-tr-round tr:first-child td:last-child {
  border-top-right-radius: 10px;
}
.cx-tr-round tr:first-child td:last-child {
  border-bottom-right-radius: 10px;
}
.cx-tr-round tr:first-child td:first-child {
  border-top-left-radius: 10px;
}
.cx-tr-round tr:first-child td:first-child {
  border-bottom-left-radius: 10px;
}

.cx-pionter {
  cursor: pointer;
}

.form-check-input:checked {
  background-color: #055D9D;
}

.Description_text {
  font-size: 16px;
  margin: 10px 0px;
  font-weight: bold;
}

.modal-img-box {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
}
.modal-img-box .article_img {
  width: 50%;
  object-fit: cover;
}

.edit-modal-img-box {
  width: 50%;
  height: auto;
  display: flex;
  justify-content: center;
}
.edit-modal-img-box .article_img {
  width: 50%;
  object-fit: cover;
}

p.single-line-elipsis {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; /* start showing ellipsis when 3rd line is reached */
  white-space: pre-wrap;
}

.doc_img {
  height: 100%;
}

.artcle_btnFalse {
  border: none;
  color: #fff;
  padding: 7px 10px;
  background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);
  border-radius: 10px 0px;
}

.word_weap {
  word-wrap: break-word;
}

.support_main {
  background: linear-gradient(120deg, rgba(0, 126, 204, 0.3411764706) 0%, rgba(236, 0, 140, 0.2509803922) 100%);
}

.support_link {
  text-decoration: none;
  text-align: end;
  font-size: 16px;
  font-weight: 600;
}

.support_link :hover {
  color: hotpink;
  text-decoration: underline;
}

.subject_label {
  font-size: 18px;
  font-weight: 600;
  color: #013053;
  text-transform: capitalize;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/globalStyle.scss"],"names":[],"mappings":"AAOA;EACE,kCAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;EAEA,oCAAA;EACA,qBAAA,EAAA,qCAAA;EACA,6BAAA,EAAA,gCAAA;AALF;;AASA,sEAAA;AACA;EACE,UAAA,EAAA,2BAAA;AANF;;AASA;EACE,mBAAA,EAAA,4CAAA;EACA,mBAAA;AANF;;AASA;EACE,sBAAA,EAAA,iCAAA;EACA,mBAAA,EAAA,4CAAA;EACA,yBAAA,EAAA,gDAAA;AANF;;AASA;EACE,gBAAA,EAAA,iDAAA;AANF;;AASA;EACE,oBAAA;EACA,4BAAA;EAGA,iBAAA;EAEA,4BAAA;EACF,sBAAA;AATA;;AAcA;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AAXF;AAgBA;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AAdF;AAoBA;EACE,eAAA;EACA,yCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AAlBF;AAyBA;EACE,eAAA;EACA,2BAAA;EACA,YAAA;EACA,wCAAA;EACA,6BAAA;EACA,oCAAA;EACA,yBAAA;AAvBF;AAwBE;EACE,sBAAA;EACA,eAAA;AAtBJ;;AA0BA;EACE,eAAA;EACA,2BAAA;EACA,YAAA;EACA,wCAAA;EACA,6BAAA;EACA,oCAAA;EACA,yBAAA;AAvBF;AAwBE;EACE,sBAAA;EACA,eAAA;AAtBJ;;AA0BA;EACE,eAAA;EACA,2BAAA;EACA,6BAAA;EACA,oCAAA;EACA,yBAAA;AAvBF;AAwBE;EACE,sBAAA;EACA,eAAA;AAtBJ;;AAyBA;EACE,eAAA;EACA,2BAAA;EACA,YAAA;EACA,6BAAA;EACA,oCAAA;EACA,yBAAA;AAtBF;AAuBE;EACE,sBAAA;EACA,eAAA;AArBJ;;AA0BA;EACE,gBAAA;EACA,eAAA;EACA,4BAAA;AAvBF;;AA0BA;EACE,gBAAA;EACA,eAAA;EACA,4BAAA;AAvBF;;AA0BA;EACE,gBAAA;EACA,eAAA;EACA,6BAAA;AAvBF;;AA0BA;EACE,gBAAA;EACA,eAAA;EACA,4BAAA;AAvBF;;AA0BA;EACE,gBAAA;EACA,eAAA;EACA,4BAAA;AAvBF;;AA0BA;EACE,gBAAA;EACA,eAAA;EACA,4BAAA;AAvBF;;AA0BA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAvBF;;AA4BA;EACE,6BAAA;AAzBF;;AA2BA;EACE,gCAAA;AAxBF;;AA0BA;EACE,+BAAA;AAvBF;;AAyBA;EACE,8BAAA;AAtBF;;AAyBA;EACE,yBAAA;AAtBF;;AA2BA;EACE,aAAA;EACA,mBAAA;EACA,8CAAA;EACA,iDAAA;AAxBF;;AA2BA;EACE,mBAAA;EACA,8CAAA;EACA,iDAAA;EACA,mBAAA;EACA,aAAA;AAxBF;;AA2BA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AAxBF;;AA0BA;EACE,kBAAA;AAvBF;;AAyBA;EACE,mBAAA;AAtBF;;AAwBA;EACE,mBAAA;AArBF;;AAuBA;EACE,mBAAA;AApBF;;AAwBA;EACE,aAAA;AArBF;;AAwBA;EACE,YAAA;AArBF;;AAwBA;EACE,WAAA;AArBF;;AAyBA;EACE,SAAA;AAtBF;;AAwBA;EACE,WAAA;AArBF;;AAuBA;EACE,YAAA;AApBF;;AAuBA;EACE,YAAA;AApBF;;AAsBA;EACE,YAAA;AAnBF;;AAqBA;EACE,YAAA;AAlBF;;AAoBA;EACE,YAAA;AAjBF;;AAmBA;EACE,YAAA;AAhBF;;AAqBA;EACE,aAAA;AAlBF;;AAoBA;EACE,eAAA;AAjBF;;AAmBA;EACE,gBAAA;AAhBF;;AAmBA;EACE,gBAAA;AAhBF;;AAmBA;EACE,gBAAA;AAhBF;;AAkBA;EACE,gBAAA;AAfF;;AAiBA;EACE,gBAAA;AAdF;;AAiBA;EACE,gBAAA;AAdF;;AAgBA;EACE,gBAAA;AAbF;;AAgBA;EACE,gBAAA;AAbF;;AAeA;EACE,gBAAA;AAZF;;AAcA;EACE,gBAAA;AAXF;;AAaA;EACE,gBAAA;AAVF;;AAYA;EACE,gBAAA;AATF;;AAWA;EACE,iBAAA;AARF;;AAaA;EACE,gBAAA;AAVF;;AAaA;EACE,kBAAA;AAVF;;AAYA;EACE,mBAAA;AATF;;AAYA;EACE,mBAAA;AATF;;AAYA;EACE,mBAAA;AATF;;AAWA;EACE,mBAAA;AARF;;AAUA;EACE,mBAAA;AAPF;;AAUA;EACE,mBAAA;AAPF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,mBAAA;AANF;;AAQA;EACE,mBAAA;AALF;;AAOA;EACE,mBAAA;AAJF;;AAMA;EACE,mBAAA;AAHF;;AAKA;EACE,mBAAA;AAFF;;AAIA;EACE,oBAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAGA;EACE,gBAAA;AAAF;;AAEA;EACE,iBAAA;AACF;;AACA;EACE,iBAAA;AAEF;;AAAA;EACE,iBAAA;AAGF;;AADA;EACE,iBAAA;AAIF;;AAFA;EACE,gBAAA;AAKF;;AAHA;EACE,iBAAA;AAMF;;AAFA;EACE,iBAAA;AAKF;;AAHA;EACE,iBAAA;AAMF;;AADA;EACE,oDAAA;EACA,mBAAA;EACA,yBAAA;AAIF;;AADA;EAEE,WAAA;EACA,UAAA;EACA,yBAAA;AAGF;;AAAA;EACE,mBAAA;EACA,oDAAA;EACA,iCAAA;AAGF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAEF;;AACA;EACE,uBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;AAAF;;AAKA;EACE,iCAAA;EACA,kCAAA;EACA,0CAAA;EACA,0CAAA;EACA,0CAAA;EACA,0CAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,iCAAA;EACA,iCAAA;EACA,sDAAA;EACA,yDAAA;EAEA,iCAAA;EAEA,2CAAA;EACA,4CAAA;EAEA,gCAAA;EACA,qDAAA;EAEA,gCAAA;EAEA,+BAAA;EAEA,iCAAA;EACA,iCAAA;EACA,iCAAA;EAEA,iCAAA;EAEA,iCAAA;EACA,iCAAA;AAVF;;AAcE;EACE,6BAAA;AAXJ;AAaE;EACE,gCAAA;AAXJ;AAaE;EACE,4BAAA;AAXJ;AAaE;EACE,+BAAA;AAXJ;;AAgBA;EACE,eAAA;AAbF;;AAgBA;EACE,yBAAA;AAbF;;AAiBA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAdF;;AAgBA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AAbA;AAcE;EACF,UAAA;EACI,iBAAA;AAZJ;;AAgBA;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AAbF;AAcI;EACF,UAAA;EACI,iBAAA;AAZN;;AAgBA;EACE,gBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA,EAAA,oDAAA;EACA,qBAAA;AAbF;;AAgBA;EACE,YAAA;AAbF;;AAgBA;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,iEAAA;EACA,uBAAA;AAbF;;AAiBA;EACE,qBAAA;AAdF;;AAgBA;EACE,6GAAA;AAbF;;AAgBA;EACE,qBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAbF;;AAiBA;EACE,cAAA;EACA,0BAAA;AAdF;;AAgBA;EACE,eAAA;EACE,gBAAA;EACA,cAAA;EACA,0BAAA;AAbJ","sourcesContent":["\n\n\n\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat&display=swap\");\n\n* {\n  font-family: \"Poppins\", sans-serif;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  // scrollbar-width: none;\n  /* Remove the scrollbar in Firefox */\n  scrollbar-width: thin; /* Thin scrollbar width for Firefox */\n  scrollbar-color: #888 #f1f1f1; /* Scrollbar color for Firefox */\n}\n\n\n/* Scrollbar styles for Webkit-based browsers (Chrome, Safari, etc.) */\n::-webkit-scrollbar {\n  width: 8px; /* Width of the scrollbar */\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1; /* Background color of the scrollbar track */\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #888; /* Color of the scrollbar thumb */\n  border-radius: 10px; /* Rounded corners for the scrollbar thumb */\n  border: 2px solid #f1f1f1; /* Optional: border around the scrollbar thumb */\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #555; /* Color when hovering over the scrollbar thumb */\n}\n\n#cx-main{\n  transition: all 0.5s;\n  padding: 60px 20px 20px  20px;\n  // background: #E5E9EB 0% 0% no-repeat padding-box;\n  // min-height: calc(100vh - 60px);\n  min-height: 100vh;\n  // background-image: url(../images/images/general/bg.svg);\n  background-repeat: no-repeat;\nbackground-size: cover;\n}\n\n// ||===========================> BUTTONS  <==============================||\n\n.cx-btn-1 {\n  cursor: pointer;\n  background-color: #53b7e8;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 21px;\n  color: #ffffff;\n  border-radius: 10px;\n  padding: 7px 20px;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n\n  &:hover {\n  }\n}\n.cx-btn-2 {\n  cursor: pointer;\n  background-color: #7353e8;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 21px;\n  color: #ffffff;\n  border-radius: 10px;\n  padding: 7px 20px;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n\n  &:hover {\n  }\n}\n\n.cx-btn-3 {\n  cursor: pointer;\n  background-color: rgba(83, 183, 232, 0.1);\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 21px;\n  color: #53b7e8;\n  border-radius: 10px;\n  padding: 7px 20px;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  &:hover {\n  }\n}\n\n// ||===========================> INPUTS <==============================||\n\n.cx-input-1 {\n  font-size: 14px;\n  line-height: 2.5 !important;\n  height: 38px;\n  border: 0.956px solid #53b7e8 !important;\n  border-radius: 5px !important;\n  background-color: #ffffff !important;\n  color: #000000 !important;\n  &::placeholder {\n    color: gray !important;\n    font-size: 14px;\n  }\n}\n\n.cx-input-2 {\n  font-size: 14px;\n  line-height: 2.5 !important;\n  height: 38px;\n  border: 0.956px solid #53b7e8 !important;\n  border-radius: 5px !important;\n  background-color: #ffffff !important;\n  color: #000000 !important;\n  &::placeholder {\n    color: gray !important;\n    font-size: 14px;\n  }\n}\n\n.cx-input-radio {\n  font-size: 14px;\n  line-height: 2.5 !important;  \n  border-radius: 5px !important;\n  background-color: #ffffff !important;\n  color: #000000 !important;\n  &::placeholder {\n    color: gray !important;\n    font-size: 14px;\n  }\n}\n.cx-input-check {\n  font-size: 14px;\n  line-height: 2.5 !important;\n  height: 38px;\n  border-radius: 5px !important;\n  background-color: #ffffff !important;\n  color: #000000 !important;\n  &::placeholder {\n    color: gray !important;\n    font-size: 14px;\n  }\n}\n\n// ||===========================> HEADINGS <==============================||\n.cx-heading-1 {\n  font-weight: 600;\n  font-size: 18px;\n  color: rgba(17, 17, 17, 0.8);\n}\n\n.cx-heading-2 {\n  font-weight: 600;\n  font-size: 16px;\n  color: rgba(17, 17, 17, 0.8);\n}\n\n.cx-heading-3 {\n  font-weight: 600;\n  font-size: 14px;\n  color: rgba(209, 38, 38, 0.8);\n}\n\n.cx-label-1 {\n  font-weight: 400;\n  font-size: 14px;\n  color: rgba(17, 17, 17, 0.6);\n}\n\n.cx-label-2 {\n  font-weight: 400;\n  font-size: 14px;\n  color: rgba(17, 17, 17, 0.6);\n}\n\n.cx-key {\n  font-weight: 400;\n  font-size: 12px;\n  color: rgba(17, 17, 17, 0.5);\n}\n\n.cx-value {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  color: #111111;\n}\n\n// ||===========================> BORDERS <==============================||\n\n.cx-bt {\n  border-top: 1px solid #ddeaf3;\n}\n.cx-bb {\n  border-bottom: 1px solid #ddeaf3;\n}\n.cx-br {\n  border-right: 1px solid #ddeaf3;\n}\n.cx-bl {\n  border-left: 1px solid #ddeaf3;\n}\n\n.cx-b {\n  border: 1px solid #ddeaf3;\n}\n\n// ||===========================> CARDS & BOXES <==============================||\n\n.cx-card {\n  padding: 20px;\n  background: #ffffff;\n  border: 0.956px solid rgba(135, 135, 135, 0.1);\n  box-shadow: 4px 4px 10px rgba(182, 182, 182, 0.1);\n}\n\n.cx-card-round {\n  background: #ffffff;\n  border: 0.956px solid rgba(135, 135, 135, 0.1);\n  box-shadow: 4px 4px 10px rgba(182, 182, 182, 0.1);\n  border-radius: 15px;\n  padding: 30px;\n}\n\n.cx-circle {\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n}\n.cx-circle-5 {\n  border-radius: 5px;\n}\n.cx-circle-10 {\n  border-radius: 10px;\n}\n.cx-circle-20 {\n  border-radius: 20px;\n}\n.cx-circle-15 {\n  border-radius: 15px;\n}\n// ||===========================> UNITS <==============================||\n\n.cx-vh100 {\n  height: 100vh;\n}\n\n.cx-vh50 {\n  height: 50vh;\n}\n\n.cx-vw100 {\n  width: 100%;\n}\n\n// ----MARGIN----\n.cx-m-0 {\n  margin: 0;\n}\n.cx-m-5 {\n  margin: 5px;\n}\n.cx-m-10 {\n  margin: 10px;\n}\n\n.cx-m-15 {\n  margin: 15px;\n}\n.cx-m-20 {\n  margin: 20px;\n}\n.cx-m-30 {\n  margin: 30px;\n}\n.cx-m-40 {\n  margin: 40px;\n}\n.cx-m-50 {\n  margin: 50px;\n}\n\n// ---------MARGIN TOP --------\n\n.cx-mt-0 {\n  margin-top: 0;\n}\n.cx-mt-5 {\n  margin-top: 5px;\n}\n.cx-mt-10 {\n  margin-top: 10px;\n}\n\n.cx-mt-15 {\n  margin-top: 15px;\n}\n\n.cx-mt-20 {\n  margin-top: 20px;\n}\n.cx-mt-25 {\n  margin-top: 25px;\n}\n.cx-mt-30 {\n  margin-top: 30px;\n}\n\n.cx-mt-35 {\n  margin-top: 35px;\n}\n.cx-mt-40 {\n  margin-top: 40px;\n}\n\n.cx-mt-50 {\n  margin-top: 50px;\n}\n.cx-mt-60 {\n  margin-top: 60px;\n}\n.cx-mt-70 {\n  margin-top: 70px;\n}\n.cx-mt-80 {\n  margin-top: 80px;\n}\n.cx-mt-90 {\n  margin-top: 90px;\n}\n.cx-mt-100 {\n  margin-top: 100px;\n}\n\n// -----------MARGIN BOTTOM----------\n\n.cx-mb-0 {\n  margin-bottom: 0;\n}\n\n.cx-mb-5 {\n  margin-bottom: 5px;\n}\n.cx-mb-10 {\n  margin-bottom: 10px;\n}\n\n.cx-mb-15 {\n  margin-bottom: 15px;\n}\n\n.cx-mb-20 {\n  margin-bottom: 20px;\n}\n.cx-mb-25 {\n  margin-bottom: 25px;\n}\n.cx-mb-30 {\n  margin-bottom: 30px;\n}\n\n.cx-mb-35 {\n  margin-bottom: 35px;\n}\n.cx-mb-40 {\n  margin-bottom: 40px;\n}\n\n.cx-mb-50 {\n  margin-bottom: 50px;\n}\n.cx-mb-60 {\n  margin-bottom: 60px;\n}\n.cx-mb-70 {\n  margin-bottom: 70px;\n}\n.cx-mb-80 {\n  margin-bottom: 80px;\n}\n.cx-mb-90 {\n  margin-bottom: 90px;\n}\n.cx-mb-100 {\n  margin-bottom: 100px;\n}\n// --------  MARGIN LEFT ---------\n.cx-ml-0 {\n  margin-left: 0px;\n}\n.cx-ml-5 {\n  margin-left: 5px;\n}\n.cx-ml-10 {\n  margin-left: 10px;\n}\n.cx-ml-15 {\n  margin-left: 15px;\n}\n.cx-ml-20 {\n  margin-left: 20px;\n}\n.cx-ml-25 {\n  margin-left: 25px;\n}\n.cx-ml-30 {\n  margin-left: 0px;\n}\n.cx-ml-40 {\n  margin-left: 40px;\n}\n\n// --------  MARGIN RIGHT ---------\n.cx-mr-0 {\n  margin-right: 0px;\n}\n.cx-mr-5 {\n  margin-right: 5px;\n}\n\n// ||===========================> SCROLLS <==============================||\n\n::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  background-color: #f5f5f5;\n}\n\n::-webkit-scrollbar {\n  // display: none;\n  height: 5px;\n  width: 5px;\n  background-color: #f5f5f5;\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: rgba(5, 93, 157, 1);\n}\n\n// ------------- Flex ------------\n.cx-flex-all{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cx-flex-x{\n  justify-content: center;\n}\n\n.cx-flex-y{\n  align-items: center;\n}\n\n// -------------- Position ----------------\n\n.cx-p-r{\n  position: relative;\n}\n\n.cx-p-a{\n  position: absolute;\n}\n\n.cx-p-f{\n  position: fixed;\n}\n\n.cx-p-s{\n  position: sticky;\n}\n\n.cx-p-center{\n  position: absolute;\n  left: 50%;\n  right: 50%;\n  transform: translate(-50%, -50%);\n}\n\n\n// ||===========================> COLORS <==============================||\nbody{\n  --backColorMainLightMode: #beddda;\n  --backColorMainDarksecond: #ddeaf3;\n  --gray_05_LightMode: rgba(17, 17, 17, 0.5);\n  --gray_08_LightMode: rgba(17, 17, 17, 0.8);\n  --gray_03_LightMode: rgba(17, 17, 17, 0.3);\n  --gray_02_LightMode: rgba(17, 17, 17, 0.2);\n  --gray_455A64_LightMode: #455a64;\n  --gray_666666_LightMode: #666666;\n  --gray_81888C_LightMode: #ddeaf3;\n  --green_06685E_LightMode: #06685e;\n  --green_3DA298_LightMode: #3da298;\n  --greenLight_3DA298_LightMode: rgba(61, 162, 152, 0.1);\n  --greenLight_3DA298_02_LightMode: rgba(61, 162, 152, 0.2);\n  \n  --green_009253_LightMode: #009253;\n  \n  --blueBorderColor_53B7E8_LightMode: #53b7e8;\n  --greenBorderColor_3DA298_LightMode: #3da298;\n  \n  --blue_53B7E8_LightMode: #53b7e8;\n  --blueLight_53B7E8_LightMode: rgba(83, 183, 232, 0.1);\n  \n  --blue_deeplight_EEF8FD: #eef8fd;\n  \n  --red_EE1D52_LightMode: #ee1d52;\n  \n  --black_111111_LightMode: #111111;\n  --black_232122_LightMode: #232122;\n  --black_000000_LightMode: #000000;\n  \n  --black_333333_LightMode: #333333;\n  \n  --white_FFFFFF_LightMode: #ffffff;\n  --white_FFFBFB_LightMode: #fffbfb;\n}\n// --------- Table row round ---------------\n.cx-tr-round{\n  tr:first-child td:last-child {\n    border-top-right-radius: 10px;\n  }\n  tr:first-child td:last-child {\n    border-bottom-right-radius: 10px;\n  }\n  tr:first-child td:first-child {\n    border-top-left-radius: 10px;\n  }\n  tr:first-child td:first-child {\n    border-bottom-left-radius: 10px;\n  }\n}\n\n// ------- Cursor -----------\n.cx-pionter{\n  cursor: pointer;\n}\n\n.form-check-input:checked{\n  background-color: #055D9D;\n}\n\n//\n.Description_text{\n  font-size: 16px;\n  margin: 10px 0px;\n  font-weight: bold;\n}\n.modal-img-box{\nwidth: 100%;\nheight: auto;\ndisplay: flex;\njustify-content: center;\n  .article_img{\nwidth: 50%;\n    object-fit: cover;\n  }\n}\n\n.edit-modal-img-box{\n  width: 50%;\n  height: auto;\n  display: flex;\n  justify-content: center;\n    .article_img{\n  width: 50%;\n      object-fit: cover;\n    }\n  }\n\np.single-line-elipsis{\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1; /* start showing ellipsis when 3rd line is reached */\n  white-space: pre-wrap;\n}\n\n.doc_img{\n  height:100%;\n}\n\n.artcle_btnFalse{\n  border: none;\n  color: #fff;\n  padding: 7px 10px;\n  background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);\n  border-radius: 10px 0px;\n}\n\n\n.word_weap{\n  word-wrap: break-word;\n}\n.support_main{\n  background: linear-gradient(120deg, rgba(0, 126, 204, 0.3411764706) 0%, rgba(236, 0, 140, 0.2509803922) 100%);\n}\n\n.support_link{\n  text-decoration: none;\n  text-align: end; \n  font-size: 16px;\n  font-weight: 600;\n\n}\n\n.support_link :hover {\n  color: hotpink;\n  text-decoration: underline;\n}\n.subject_label{\n  font-size: 18px;\n    font-weight: 600;\n    color: #013053;\n    text-transform: capitalize;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
